import { Inject, Injectable, signal } from '@angular/core';
import { SelectedLineResil } from '../models/selected-line';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { WINDOW } from '@sfcu/sfc-front-starter';
import { reponseSelection } from './json-mocks/reponse-selection';

@Injectable({
  providedIn: 'root'
})
export class IdentificationService {

    private url: string;
    public readonly selectedLineNumber = signal<string | undefined>(undefined);

    constructor(private httpClient: HttpClient,
                @Inject(WINDOW) private window: Window) {

        this.url = this.window.location?.origin + '/resiliation-ws/rest/ligne/selection';
    }

    getSelection(isDistrib = false): Observable<SelectedLineResil> {
        const headers: HttpHeaders = new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'secure': 'false'
        });

        let urlQueryParam = '';
        if(isDistrib) {
            urlQueryParam = this.window.location.search;
        }
        return this.window.location.origin.includes('localhost')
            ? of(reponseSelection)
            : this.httpClient.get<SelectedLineResil>(this.url + urlQueryParam, { headers });
    }
    getSelectedLineNumber(): string | undefined {
        return this.selectedLineNumber();
    }

    setSelectedLineNumber(line: string): void {
        this.selectedLineNumber.set(line);
    }
}
